import { useState, useEffect, useRef } from 'react';

export default function SlashPicker({
  inputRef,
  pinnedRefExpanded,
  pinnedReference,
  playbookItems,
  setInput,
  setPinnedRefExpanded,
  setPinnedReference,
  setShowSlashPicker,
  showSlashPicker,
  slashQuery,
  session,
  isMobile,
}) {
  return (
    <>
    {(() => {
            {showSlashPicker && (
              <div style={{ position: 'absolute', bottom: '100%', left: 0, right: 0, marginBottom: '8px', background: '#111', border: '1px solid #252525', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 -8px 32px rgba(0,0,0,0.6)', zIndex: 100, maxHeight: '280px', display: 'flex', flexDirection: 'column', fontFamily: 'Georgia, serif' }}>
                <div style={{ padding: '10px 14px 6px', color: '#444', fontSize: '10px', letterSpacing: '0.12em', textTransform: 'uppercase', flexShrink: 0 }}>
                  Playbook {slashQuery && <span style={{ color: '#666' }}>— {slashQuery}</span>}
                </div>
                <div style={{ overflowY: 'auto', flex: 1 }}>
                  {playbookItems
                    .filter(item => !slashQuery || item.title?.toLowerCase().includes(slashQuery) || item.type?.toLowerCase().includes(slashQuery))
                    .slice(0, 12)
                    .map((item, i) => {
                      const typeColor = item.type === 'template' ? '#c8a96e' : item.type === 'cheatsheet' ? '#7a9e82' : '#9b8fc4';
                      return (
                        <button key={i} onClick={() => {
                          setPinnedReference(item);
                          setPinnedRefExpanded(true);
                          setShowSlashPicker(false);
                          setInput('');
                          if (inputRef.current) inputRef.current.innerText = '';
                        }}
                          style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', background: 'none', border: 'none', borderBottom: '1px solid #1e1e2a', padding: '10px 14px', cursor: 'pointer', textAlign: 'left', transition: 'background 0.1s' }}
                          onMouseEnter={e => e.currentTarget.style.background = '#1e1e2a'}
                          onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                          <span style={{ fontSize: '10px', letterSpacing: '0.08em', textTransform: 'uppercase', color: typeColor, border: '1px solid ' + typeColor + '44', borderRadius: '4px', padding: '2px 6px', flexShrink: 0 }}>{item.type}</span>
                          <span style={{ color: '#d4d4d4', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.title}</span>
                        </button>
                      );
                    })}
                  {playbookItems.filter(item => !slashQuery || item.title?.toLowerCase().includes(slashQuery) || item.type?.toLowerCase().includes(slashQuery)).length === 0 && (
                    <div style={{ color: '#333', fontSize: '13px', fontStyle: 'italic', padding: '16px 14px' }}>No items match &ldquo;{slashQuery}&rdquo;</div>
                  )}
                </div>
              </div>
            )}

            {/* ── Pinned reference card ── */}
            {pinnedReference && (
              <div style={{ marginBottom: '8px', background: '#111', border: '1px solid #252525', borderRadius: '8px', overflow: 'hidden', fontFamily: 'Georgia, serif' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 12px', cursor: 'pointer' }} onClick={() => setPinnedRefExpanded(v => !v)}>
                  {(() => { const typeColor = pinnedReference.type === 'template' ? '#c8a96e' : pinnedReference.type === 'cheatsheet' ? '#7a9e82' : '#9b8fc4'; return (
                    <span style={{ fontSize: '10px', letterSpacing: '0.08em', textTransform: 'uppercase', color: typeColor, border: '1px solid ' + typeColor + '44', borderRadius: '4px', padding: '2px 6px', flexShrink: 0 }}>{pinnedReference.type}</span>
                  ); })()}
                  <span style={{ color: '#888', fontSize: '12px', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{pinnedReference.title}</span>
                  <span style={{ color: '#444', fontSize: '11px', flexShrink: 0 }}>{pinnedRefExpanded ? '▲' : '▼'}</span>
                  <button onClick={e => { e.stopPropagation(); setPinnedReference(null); }}
                    style={{ background: 'none', border: 'none', color: '#333', fontSize: '16px', cursor: 'pointer', lineHeight: 1, padding: '0 2px', flexShrink: 0 }}
                    onMouseEnter={e => e.currentTarget.style.color = '#888'}
                    onMouseLeave={e => e.currentTarget.style.color = '#333'}>×</button>
                </div>
                {pinnedRefExpanded && (
                  <div style={{ padding: '0 12px 12px', maxHeight: '200px', overflowY: 'auto', borderTop: '1px solid #1e1e2a' }}>
                    <div style={{ color: '#666', fontSize: '13px', lineHeight: '1.85', fontFamily: 'Georgia, serif', whiteSpace: 'pre-wrap', paddingTop: '10px' }}>
                      {typeof pinnedReference.content === 'string'
                        ? pinnedReference.content
                        : [pinnedReference.content?.purpose, ...(pinnedReference.content?.blocks || []).map(b => b.heading + (b.body ? ': ' + b.body : ''))].filter(Boolean).join('\n\n')}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* ── Slash command picker ── */}
            {showSlashPicker && (
              <div style={{ position: 'absolute', bottom: '100%', left: 0, right: 0, marginBottom: '8px', background: '#111', border: '1px solid #252525', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 -8px 32px rgba(0,0,0,0.6)', zIndex: 100, maxHeight: '280px', display: 'flex', flexDirection: 'column', fontFamily: 'Georgia, serif' }}>
                <div style={{ padding: '10px 14px 6px', color: '#444', fontSize: '10px', letterSpacing: '0.12em', textTransform: 'uppercase', flexShrink: 0 }}>
                  Playbook {slashQuery && <span style={{ color: '#666' }}>— {slashQuery}</span>}
                </div>
                <div style={{ overflowY: 'auto', flex: 1 }}>
                  {playbookItems
                    .filter(item => !slashQuery || item.title?.toLowerCase().includes(slashQuery) || item.type?.toLowerCase().includes(slashQuery))
                    .slice(0, 12)
                    .map((item, i) => {
                      const typeColor = item.type === 'template' ? '#c8a96e' : item.type === 'cheatsheet' ? '#7a9e82' : '#9b8fc4';
                      return (
                        <button key={i} onClick={() => {
                          setPinnedReference(item);
                          setPinnedRefExpanded(true);
                          setShowSlashPicker(false);
                          setInput('');
                          if (inputRef.current) inputRef.current.innerText = '';
                        }}
                          style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', background: 'none', border: 'none', borderBottom: '1px solid #1e1e2a', padding: '10px 14px', cursor: 'pointer', textAlign: 'left', transition: 'background 0.1s' }}
                          onMouseEnter={e => e.currentTarget.style.background = '#1e1e2a'}
                          onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                          <span style={{ fontSize: '10px', letterSpacing: '0.08em', textTransform: 'uppercase', color: typeColor, border: '1px solid ' + typeColor + '44', borderRadius: '4px', padding: '2px 6px', flexShrink: 0 }}>{item.type}</span>
                          <span style={{ color: '#d4d4d4', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.title}</span>
                        </button>
                      );
                    })}
                  {playbookItems.filter(item => !slashQuery || item.title?.toLowerCase().includes(slashQuery) || item.type?.toLowerCase().includes(slashQuery)).length === 0 && (
                    <div style={{ color: '#333', fontSize: '13px', fontStyle: 'italic', padding: '16px 14px' }}>No items match &ldquo;{slashQuery}&rdquo;</div>
                  )}
                </div>
              </div>
            )}
    })()}
    </>
  );
}
